import {useStore} from "vuex";
export default {
    data: () => ({store: useStore()}),
    methods: {
        doOctoberRequest(requestName, data, messages = false, silent = false) {
            return new Promise((resolve, reject) => {
                if (window.projectId) {
                    if (data) data.project = window.projectId;
                    else data = {project: window.projectId};
                }
                $.request(requestName, {
                    data: data,
                    error: (jqXHR) => {
                        const message = this.backendMessage(jqXHR)
                            || 'Ein Fehler ist aufgetreten / An error occurred.';
                        UIkit.notification({
                            message: '<span uk-icon="warning"></span> ' + message,
                            status: 'danger',
                            pos: 'bottom-center',
                            timeout: 7000,
                        });
                        // @gotcha Reject with the jqXHR, NEVER with the parsed body. Callers
                        //   read `responseJSON` / `responseText` / `statusText` off whatever
                        //   arrives here; handing them the body alone leaves all three
                        //   undefined, so SummaryPayment.placeOrder()'s layered fallback chain
                        //   missed on every branch and fell through to its generic wording.
                        //   Result: a buyer whose departure was sold out read "Bitte versuche
                        //   es später nochmal" while the real reason sat in the response the
                        //   whole time (2026-08-27).
                        reject(jqXHR);
                    },
                    success: (data) => (resolve(data))
                });
            });
        },
        emitEvent(name, detail) {
            const event = new CustomEvent('Festiware::' + name, {detail});
            window.dispatchEvent(event);
        },
        /**
         * The backend's own wording for a failed request, or null when it did not send
         * one worth reading. Callers fall back to their own copy in that case.
         *
         * @gotcha The placeholder list is the whole point. Laravel answers anything that
         *   is not an HttpException with the literal string "Server Error" once debug is
         *   off, and statusText is never more than "Internal Server Error" — so a naive
         *   `responseJSON.message || statusText` chain reports those to the buyer as if
         *   they explained something. They are worse than the shop's own sentence, which
         *   at least tells him to try again later.
         */
        backendMessage(jqXHR) {
            const placeholders = [
                'Server Error',
                'Internal Server Error',
                'Bad Request',
                'Not Found',
                'Forbidden',
                'Unprocessable Content',
                'Unprocessable Entity',
                'Service Unavailable',
            ];
            const usable = (text) => typeof text === 'string'
                && text.trim() !== ''
                && !placeholders.includes(text.trim());

            const fromBody = jqXHR?.responseJSON?.X_OCTOBER_ERROR_MESSAGE
                || jqXHR?.responseJSON?.message
                || jqXHR?.responseJSON?.error;

            if (usable(fromBody)) {
                return fromBody;
            }

            // A non-JSON body can still be the message itself (older October versions
            // answered an AJAX handler in plain text). An HTML error page or a JSON blob
            // is not, so those are excluded rather than printed at the buyer.
            const raw = (jqXHR?.responseText ?? '').trim();

            if (usable(raw) && raw.length < 500 && !raw.startsWith('<') && !raw.startsWith('{')) {
                return raw;
            }

            return null;
        },
        emitError(type, message, onlyNotification = false, errorHeadline = '') {
            const detail = {type, message, onlyNotification, errorHeadline};
            this.emitEvent('Error', detail);
            this.$emit('error', detail);
        },
        getPrice(ticket, selection) {
            let price = ticket.price;
            if (ticket.included_products) {
                ticket.included_products.forEach((product) => {
                    price -= parseFloat(product.attributes.price);
                })
            }
            return this.$filters.currency(price * (selection?selection:1));
        },
        getIncludedProducts(ticket) {
            let includedProducts = ''
            ticket.included_products.forEach((product) => {
                includedProducts += '<span>+ '+this.$filters.currency(product.attributes.price)+' '+product.attributes.title+'</span><br>';
            })
            return includedProducts;
        },
        trackMetaPixel(eventName, params = {}) {
            if (typeof window.fbq === 'function') {
                window.fbq('track', eventName, params);
            }
        },
        trackGA(eventName, params = {}) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', eventName, params);
            }
        },
        trackMatomo(action, ...args) {
            if (window._paq) {
                window._paq.push([action, ...args]);
            }
        }
    },
};
